import React from 'react';
import {  Pressable } from 'react-native';
import { Icon, IconButton } from 'react-native-paper';
import { Custom_Icons } from '../shared/constants/custom-icons';
import { Props } from 'react-native-paper/lib/typescript/components/IconButton/IconButton';
import { useThemeSettings } from '../ThemeProvider';

interface CustomIconProps extends Props {
  size?: number;
  color?: string;
  isPressable?: boolean;
  onPress?: () => void;
};

export const CustomIcon = ({ icon, size = 24, isPressable = false, onPress, ...rest }: CustomIconProps) => {
  const { theme } = useThemeSettings();

  // Resolve the icon component or image URL depending on the platform
  const IconComponent = Custom_Icons[icon as keyof typeof Custom_Icons];

  // Set color for the icon, using the theme if no color is provided
  const color = rest?.color ? { color: rest?.color } : { color: theme?.colors?.primary };

  // If IconComponent is not found, fall back to default IconButton
  if (!IconComponent) {
    return isPressable ? (
      <Pressable onPress={onPress}>
        <IconButton {...rest} icon={icon} size={size} style={rest?.style} />
      </Pressable>
    ) : (
      <Icon {...rest} {...color} source={icon} size={size} />
    );
  }

  // If the icon is pressable, wrap it with a Pressable component
  if (isPressable) {
    return (
      <Pressable onPress={onPress}>
         <IconComponent {...color} width={size} height={size || 32} />
      </Pressable>
    );

  }
  // For native platforms, render the custom component (or fallback to default Icon)
  return <IconComponent {...color} width={size} height={size || 32} />;
};
